import React, { useState } from 'react';
import { LocalizationContext } from 'contexts/Localization';
import {
  BoxBaseStyled,
  ColCentered,
  ColStyled,
  ImageWrapper,
  DynamicImageMobile,
  DynamicImageDesktop,
  ButtonWrapper,
  VideoWrapper,
  IframeStyled,
  ExitArea,
  TextWrapper,
  H4Mobile,
  H4Desktop,
} from './styles';
import ButtonCircle from 'components/ButtonCircle';
import Modal from 'components/Modal';
import { Text } from 'styles/components/typography';
import { em } from 'polished';
import PropTypes from 'prop-types';

const BResultsDemo = ({ texts }) => {
  const { paths } = React.useContext(LocalizationContext);
  const [isOpened, setOpened] = useState(false);
  const toggleModal = (newState) => setOpened(newState);
  return (
    <>
      <BoxBaseStyled>
        <H4Mobile
          dangerouslySetInnerHTML={{ __html: texts.title }}
        />
        <ColStyled >
          <ImageWrapper onClick={() => toggleModal(true)}>
            <DynamicImageMobile
              image={`${paths.cdn_global}/boxes/biome-results-demo-guide-mobile`}
              imageSizes={{ xs: 320, md: 500 }}
              imageType="png"
              fitOption={'contain'}
              alt={'Microbiome Demo Mobile'}
            />
            <DynamicImageDesktop
              image={`${paths.cdn_global}/boxes/biome-results-demo-guide`}
              imageSizes={{ xs: 320, md: 500 }}
              imageType="png"
              fitOption={'contain'}
              alt={'Microbiome Demo'}
            />
            <ButtonWrapper>
              <ButtonCircle
                size="large"
                as="button"
                bgClassName="bg--white"
                blackoutClassName="bg--white"
                textClassName="text"
                icon="btn_play"
                iconColor="black"
              />
            </ButtonWrapper>
          </ImageWrapper>
        </ColStyled>
        <ColCentered width={{lg: 4 / 5}}>
          <TextWrapper>
            <H4Desktop
              dangerouslySetInnerHTML={{ __html: texts.title }}
            />
            <Text
              dangerouslySetInnerHTML={{ __html: texts.body }}
              pt={{ xs: em(2), md: em(4) }}
            />
          </TextWrapper>
        </ColCentered>
      </BoxBaseStyled>
      <Modal
        modalOpen={isOpened}
        isMobile={true}
        handleCloseModal={() => toggleModal(false)}
      >
        <VideoWrapper>
          <ExitArea onClick={() => toggleModal(false)}/>
            <IframeStyled
              src="https://www.youtube.com/embed/M2XENELMNLY"
              title="YouTube video player"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
        </VideoWrapper>
      </Modal>
    </>
  )
}

BResultsDemo.propTypes = {
  texts: PropTypes.object.isRequired,
}

BResultsDemo.defaultProps = {}

export default BResultsDemo;
